import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex mt-6 mb:mt-10 justify-center" }
const _hoisted_2 = { class: "flex-1 max-w-[812px] bg-white rounded-[20px] pt-[30px]" }
const _hoisted_3 = { class: "flex justify-start items-center md:justify-center mb-6 md:mb-10 relative" }
const _hoisted_4 = { class: "sf-pro font-semibold text-xl max-md:leading-[24px] md:text-2xl max-md:pl-4" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-[20px] overflow-y-auto"
}
const _hoisted_6 = {
  class: "w-full text-left overflow-hidden",
  ref: "tableRef"
}
const _hoisted_7 = { class: "bg-brown max-md:hidden" }
const _hoisted_8 = { class: "th-item pl-4" }
const _hoisted_9 = { class: "th-item" }
const _hoisted_10 = { class: "th-item" }
const _hoisted_11 = { class: "th-item" }
const _hoisted_12 = { class: "th-item" }
const _hoisted_13 = { class: "pl-4" }
const _hoisted_14 = { class: "max-md:hidden" }
const _hoisted_15 = { class: "max-md:hidden" }
const _hoisted_16 = { class: "max-md:hidden" }
const _hoisted_17 = { class: "flex items-center gap-4 max-md:pr-4 max-md:justify-end" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

import { useFamilyStore } from "@/stores/familyStore";
import { useI18n } from "vue-i18n";
import AddOutlineButton from "@/components/buttons/AddOutlineButton.vue";
import FamilyMemberModal from "@/views/Auth/components/FamilyMemberModal.vue";
import { onMounted, ref } from "vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import PencilIcon from "@/components/icons/PencilIcon.vue";
import { FamilyMember } from "@/types/familyTypes";
import { useToastNotificationStore } from "@/stores/toastNotificationStore";
import { useRoute } from "vue-router";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'FamilyTable',
  setup(__props) {

const familyStore = useFamilyStore();
const toastStore = useToastNotificationStore();
const { t } = useI18n();
const route = useRoute();

const showAddModal = ref(false);
const editableFamilyMember = ref<FamilyMember>();
const waitApiCall = ref(false);

onMounted(() => {
  familyStore.loadIfNeeded();

  if (route.query.openFamilyModal === "true") {
    showAddModal.value = true;
    router.replace({ query: { ...route.query, openFamilyModal: undefined } });
  }
});

function handleCloseModal() {
  showAddModal.value = false;
  editableFamilyMember.value = undefined;
}

function handleUpdateFamilyMember(familyMember: FamilyMember) {
  editableFamilyMember.value = familyMember;
  showAddModal.value = true;
}

async function handleDeleteFamilyMember(familyMember: FamilyMember) {
  if (waitApiCall.value) {
    return;
  }
  try {
    waitApiCall.value = true;
    await familyStore.deleteFamilyMember(familyMember);
  } catch (e) {
    await toastStore.createNotificationsFromApi(e);
    console.log(e);
  } finally {
    waitApiCall.value = false;
  }
}

function formatDate(rawDate: string) {
  const date = new Date(rawDate);

  return date
    .toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\./g, "-");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("family-table.title")), 1),
        (_unref(familyStore).familyMembers.length < 4)
          ? (_openBlock(), _createBlock(AddOutlineButton, {
              key: 0,
              class: "absolute right-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddModal.value = true))
            }))
          : _createCommentVNode("", true)
      ]),
      (_unref(familyStore).familyMembers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)("family-table.member.name")), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)("family-table.member.gender")), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)("family-table.member.city")), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(t)("family-table.member.birthdate")), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(t)("family-table.member.actions")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(familyStore).familyMembers, (familyMember) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: familyMember.id,
                    class: "h-20 border-b border-ternary last:border-b-0"
                  }, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(familyMember.name), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(t)(`family-table.gender.${familyMember.gender}`)), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(familyMember.city), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(formatDate(familyMember.birthdate)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["size-10 border border-muted rounded-lg", {
                      'opacity-40 pointer-events-none': waitApiCall.value,
                    }]),
                          onClick: ($event: any) => (handleDeleteFamilyMember(familyMember))
                        }, [
                          _createVNode(CloseIcon, { class: "mx-auto" })
                        ], 10, _hoisted_18),
                        _createElementVNode("button", {
                          class: _normalizeClass(["size-10 border border-muted rounded-lg", {
                      'opacity-40 pointer-events-none': waitApiCall.value,
                    }]),
                          onClick: ($event: any) => (handleUpdateFamilyMember(familyMember))
                        }, [
                          _createVNode(PencilIcon, { class: "mx-auto" })
                        ], 10, _hoisted_19)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ], 512)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FamilyMemberModal, {
      show: showAddModal.value,
      editableFamilyMember: editableFamilyMember.value,
      onClose: handleCloseModal
    }, null, 8, ["show", "editableFamilyMember"])
  ]))
}
}

})